<template>  
	<div class="about">
    <div class="row">
      <div class="col-md-2">
        
        <div class="col-md-12">
          <div class="form-group">
            <label>Criterio de consulta</label>
              <select class="form-control form-control-sm" name="criterio" id="criterio" v-model="criterio" >
                <option value="trafo">Transformador</option>
                <option value="nodo">Nodo</option>
              </select>
          </div>
        </div>
        
        <div class="col-md-12">
            <div class="form-group">
              <input id="valorBusqueda" placeholder="Ingrese el valor" type="text" class="form-control form-control-sm" v-model="valorBusqueda" />
            </div>
        </div>

        <div class="col-md-12">
          <input class="app-btn--blue btn-sm btn-block" type="button" value="Buscar" @click="searchTrafos()">
        </div>


        <div class="col-md-12" style="padding-top:10px;  display:none;">
          
          <div class="list-group">
            <a href="#" class="list-group-item list-group-item-info">
              Planos Unifilares
            </a>          
            <a href="http://crecg075.s3-website-us-east-1.amazonaws.com/unifilares/subestacionsur.jpg" class="list-group-item" download>Subestacion sur</a>
            <a href="http://crecg075.s3-website-us-east-1.amazonaws.com/unifilares/subestacionsanantonio.jpg" class="list-group-item" download>Subestacion San antonio</a>
            <a href="http://crecg075.s3-website-us-east-1.amazonaws.com/unifilares/subestacionchipichape.jpg" class="list-group-item" download>Subestacion San Chipichape</a>
            <a href="http://crecg075.s3-website-us-east-1.amazonaws.com/unifilares/subestacionsanluis.jpg" class="list-group-item" download>Subestacion San Luis</a>
            <a href="http://crecg075.s3-website-us-east-1.amazonaws.com/unifilares/subestacionmenga.jpg" class="list-group-item" download>Subestacion Menga</a>
            <a href="http://crecg075.s3-website-us-east-1.amazonaws.com/unifilares/subestacionarroyohondo.jpg" class="list-group-item" download>Subestacion Arroyohondo</a>
            <a href="http://crecg075.s3-website-us-east-1.amazonaws.com/unifilares/subestacionguachicona.jpg" class="list-group-item" download>Subestacion Guachicona</a>
            <a href="http://crecg075.s3-website-us-east-1.amazonaws.com/unifilares/subestacionguachal.jpg" class="list-group-item" download>Subestacion Guachal</a>
            <a href="http://crecg075.s3-website-us-east-1.amazonaws.com/unifilares/subestaciondiesel1.jpg" class="list-group-item" download>Subestacion Diesel 1</a>
            <a href="http://crecg075.s3-website-us-east-1.amazonaws.com/unifilares/subestacioncentro.jpg" class="list-group-item" download>Subestacion Centro</a>
            <a href="http://crecg075.s3-website-us-east-1.amazonaws.com/unifilares/subestaciondiese2.jpg" class="list-group-item" download>Subestacion Diesel 2</a>
            <a href="http://crecg075.s3-website-us-east-1.amazonaws.com/unifilares/subestacionmelendez.jpg" class="list-group-item" download>Subestacion Melendez</a>
            <a href="http://crecg075.s3-website-us-east-1.amazonaws.com/unifilares/subestacionaguablanca.jpg" class="list-group-item" download>Subestacion Aguablanca</a>
            <a href="http://crecg075.s3-website-us-east-1.amazonaws.com/unifilares/subestacionjuanchito.jpg" class="list-group-item" download>Subestacion JuanChito</a>
            <a href="http://crecg075.s3-website-us-east-1.amazonaws.com/unifilares/subestacionpuertotejada.jpg" class="list-group-item" download>Subestacion Puerto Tejada</a>
            <a href="http://crecg075.s3-website-us-east-1.amazonaws.com/unifilares/subestacionlacampiña.jpg" class="list-group-item" download>Subestacion Campiña</a>
            <a href="http://crecg075.s3-website-us-east-1.amazonaws.com/unifilares/subestacionladera.jpg" class="list-group-item" download>Subestacion Ladera</a>
            <a href="http://crecg075.s3-website-us-east-1.amazonaws.com/unifilares/subestacionladera2.jpg" class="list-group-item" download>Subestacion Ladera 115</a>
            <a href="http://crecg075.s3-website-us-east-1.amazonaws.com/unifilares/subestacionmulalo.jpg" class="list-group-item" download>Subestacion Mulalo</a>
            <a href="http://crecg075.s3-website-us-east-1.amazonaws.com/unifilares/subestacionpance.jpg" class="list-group-item" download>Subestacion Pance</a>
            <a href="http://crecg075.s3-website-us-east-1.amazonaws.com/unifilares/subestaciontermoyumbo.jpg" class="list-group-item" download>Subestacion Termoyumbo</a>
            <a href="http://crecg075.s3-website-us-east-1.amazonaws.com/unifilares/subestacionalferez1.jpg" class="list-group-item" download>Subestacion Alferez</a>
            <a href="http://crecg075.s3-website-us-east-1.amazonaws.com/unifilares/subestacionciudaddelsur.jpg" class="list-group-item" download>Subestacion Cuidad del sur</a>
          </div>
          
        </div>
      </div>

      <div class="col-md-9">
          <div>	  
            <l-map 
              v-if="showMap"
              ref="mapaCreg"
              :zoom="zoom"
              :center="center"
              :options="mapOptions"
              style="height: 700px; width: 100%"
              @update:center="centerUpdate"
              @update:zoom="zoomUpdate">
              <l-tile-layer :url="url" :attribution="attribution" />
                
              <l-marker
                  v-for="marker in markers"
                  :key="marker.id"
                  :visible="true"
                  :draggable="true"
                  :lat-lng.sync="{ lat:" +  marker.latTrafo + ", lng:" +  marker.lngTrafo + "}"
                  :icon="icons"
                  ref="markerRefs"
                  @click="alert(marker)">
              </l-marker>

              <l-marker 
                  v-for="item in items" v-bind:key="item.codTrafoDis"
                  :lat-lng="[item.latTrafo, item.lngTrafo]"
                  :icon="iconT"
                  @click="alert(marker)"
                  ref="popupRefs">

                <l-popup :content="'<p>Código del transformador:'+item.codTrafo+'</p><p>Código del circuito:'+item.codCircuito+'</p><p>Dirección del transformador: '+item.dirTrafo+'</p><p>Potencia:'+item.potencia+' kVA</p><p>Fases: '+item.fases+'</p><p>Código subestacion: '+item.codSubE+'</p>'" 
                  :latLng="[item.latTrafo, item.lngTrafo]" />
              </l-marker>
            </l-map>
          </div>
    </div>
    </div>
	</div>
  </template>

<script>
import axios from "axios";
//import trafosBusqueda from "../assets/json/trafosBusqueda.json";
import trafos from "../assets/json/trafos.json";
import { latLng, icon } from 'leaflet';
import { LMap, LTileLayer, LMarker, LPopup, LTooltip, LFeatureGroup, LIcon } from 'vue2-leaflet';

import { mapState, mapActions, mapMutations } from 'vuex';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'bootstrap/dist/css/bootstrap.css';
import CryptoJS from 'crypto-js';
  
export default {
	name: 'Example',
	components: {
	  LMap,
	  LTileLayer,
	  LMarker,
	  LPopup,
	  LTooltip,
	  LFeatureGroup,
    LIcon   
	},
	data() {
    return {
      criterio: 'trafo',
      valorBusqueda: '',
      items: [],
      trafosList:[],
      zoom: 100,
      currentZoom: 20,
		  center: latLng(3.45, -76.533333),
		  url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      withPopup: latLng(3.45, -76.533333),
      withTooltip: latLng(3.45, -76.533333),
      
      currentCenter: latLng(3.45, -76.533333),
      showParagraph: false, 
      icons: icon({
          iconUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABmJLR0QA/wD/AP+gvaeTAAAJO0lEQVR4nO2be1BU1x3HPysPX7tUMJH1AT4qPrBtohKNSjWAYxOtCVTNTBxJmjTFvjv5Iz5aJI2aBNu0Js74wLYzTaxaGa0omvhIEFelrdH6GkGwYREQEANrWZggsHv7x927e3fh7t67e6m2+p25s/fe8zvn/M7v/H6/8zu/cxce4iHU4Awg3GfXKT0GZlBJJ+jRWS9ALf+KCNdCXHLmbECazs4Ospa/Snn5NfqNiGP8bzYyeO48wk0mL7ouu52iPbvhtxvAWsn48RPYnvcHIiIie2y3rq7efb94yXNa2PaLPrq15EJh4UH34GecvUhsxqJugwfEd2nz4C9/BfNQysuvUVh4UG92NCES2ADUoYONPrZ7rzCvXRDmtQvC7H9VC7EZi4Rwk0kIN5mEIc+mC7MuXxMos4rXxs16+YWbQK5rLJqRqxMTAiCk3m5xDz4iOqZbecSgaIETJaIAPruit4PMVTtouRO5CQybVnyGQU/OVFu/G471E5uc1y76zUsvLObW/n0seGoKeeuyEASBrOztfGy5AE/Ph42bxYoTR3vVU4v2ri4sNbXiw/lzsGwJiFo8XE397j7A6dTEQCA0fXIMgG1rv8/w2BhGmAeTty5LLDxt0bWvYBYr+SqwA1h5NvWburETEIbuq5ikQSHiQ7WEcg3IweMEdUNMShoAWdnbqW1ooqa+iaw1eWJh8mw9uwKR9w3AG2orKIlbABAq8kWicc8D6uKAmbOmAR5bbqso5+zsGXTesXnRRcYMpmPfITCbxRcuH6DUR09xgFCRD43nMSRvCDQeRegeB/hi4LjxzDh3idhFSwiPiiI8Kgrz4ud58rOLnsHfQ8glFgmsAzKBoaE2rMabH7NWeR5cGhAi6hB9WQ7QoaaC3AmuBVbowcU9xDBgpet+lZoKcgFkAugVB8jRXltD+euvuZfEmJQ0EtbnQkTfbrQ6xQGZBCEAETrHAe21NfzticfptDW73zUeLMBmOQn7D4M5ZGuTIbRNq66hsLQPiM1YJADCgqemCLWntgk1lq3CM7Mni3RPz/fsB/QNhd8JRgCRLiHc1FMA4SaTAAg1lq2CUJEvCBX5QvXJrSKd0ai3ADRvhuQm0IFoN6vQIQ6Q0GW3AzDCPNj9Lm6o6761tVv9EOMAVfG/HL0eB/wvQdd8gCoTMJnuuQnINUCKA/R0y//tvYAUB7yptoLu+YBPBxtxtLWReruFcJNJcS/AoGjY/5EYDtvtMO0bhBmNpH1h19TffZcPME76OgBFe3ZzzFrFmYi+dO4/LCY/jEbxemaBZ/DgzgsYE78WUt/BxAFyDcjFE0aGjtFjxIRn1Ff8092xQcZ8aGjQrWvEsaxWQxgmu7cgOo8xQPc0rlbcscGhA2KkZx4KkT5+qbUVPj0OP1uu5+DrgC2I+QCHmgpK++fTwKxN728mKemJHgmcTidHjx7hTx/8kZqaGgBM5gQS07MZkpjK6d89i63qgiquo0dPJfm1AhpLiygtWI+94ToAcXFxfPel7zFzZjJtbW091r1y5RJvrs0B8fQqWVWHMoQpvJ8OTJ0wYSKTJnnbpdPp5MiRj1mTs5rCQwdpaWnBZE5g8rKNJL28jehRk4noH8XoOa/Qf5CZzrY7dH75b5xdd73aiegfRcyYJCYuXM3Ul7cQOTCaQfGPMTbthxjNY2mpvcrtOisWSzEnij5hwICBxMePxOCTRjt//hwXLv4T4AhwSKsAlDTg58B76enfYcXrq9wDLy4+wfbfb6O6+gYAAx8dxcSFqxkz5xUMYZoOmQJCEJzUnt3Hlb1rsNeXAzBkSCwZGYtITZlLWJg4d3nbt3D8+FGJ501a+1Hi+iqAtbLS/eJHP17O5cuXAI+qj5yxVPeBSzAY+hA3fQkjkjI4eXgXzUXraWy8Tl7eFiyWYtatFfc7kvkBpT5NSEuCQeEZUBZAKYC1yiMAafDTf/BBUAMXnA6K35lLn4i+zFlxRHU9Q1g4pikvYnx8Ka0Xd3Er/yXKyjxjra2t9uJZK5T2AnVAc0tLC01NTV4Fo5JfDGrWb5TspLGsmIbLR7VzCRj6iIKQw2az0SpuqGwEmc32txkqA7BaK/2QqIPgdFB64O2Q2/GFwuxL3zK4u+/h2f1tgT8BiH6gyhoSkyDOvuTI9ITM/q/KXquJ493LpT9dFv1AiBrQW7MPUOPRgKu+ZVIuwxdSbkNCYA0IUQA3SnZhry8nYZQxpHZ6goIGaII/AZQCVFZ+Hmzbrtl/C4DsnyQG3Y4SQl0BwL8A6gCb3W6nqemLoBqXbH/sSCNLn4sPqg0l+KwA9bKiNoC6Rlu3OrJ37lxcoPXsKpBstWp3hILTQWmBOPtrfppIeJgn/tizrHsA+uiE2aRmn1Tdfq2y/f8DSN1RYGFllve3RB/ud7f/d+kmkABKgeRg/MCNkl3YGypIGOWZ/eSkRzh9rmdtumvXpmV+IsC1QGrO+3sAyEwXs047Ciy8sSlfTgOo0wDNS6Gv7Uuzfyo/xYvO4RCY9K2jlFfambhQ1UGOG35WgJPALzo6u95a9e5Ow6p3d3qxhpgnUBUHgLQUVmrTAMn2vxrv3/b/XHCD8ko7xtixjJzxgqY+/GgAiAcj3wZOyN4VAfMRE79uqNQAbQIoKxT7+Ly6lYiEvV5lyUmPcCo/hS6HwFubywCYlJGjObz24wMkfOS6pCgwrSeiQBpQj2tPoAX9ooYolkk+YNeBaq5XtWIyj2PkzKWa2geUVgDNUCP2UjRmWlJ+eaLH95L3dzgE3t4izn5iejaGPkp5mYCQz35Q3zeoORkKOspSQii27wM5b/7ONRQ/rFarAboiFNv3gZy3TNfvLKBEbQP3RAOuV7Wqnn2H/2OKnnjTdN6phlh3DQD1s99y12+xnLcdrt9TBD5DdJuEGv2rB5qBGBW0qqBl9mvvKBY3470C5Lh+MxHPCP3B7dTVqouuWhBo9h1OsH0JpbegQ/l4w1f9pe8bhiMmPpUuL6j1QO6l8Hytyho9YMDYuQiODpril9IUQjsynkKGWgHo4giHvXpcj2Yk6MKTWhPQfSXQAbo75/vxn2HBXv7+UeaVJTb4FPw/we+H4FJ5Nx+wIfe93mKo12Br9qyVub/+lXSrakIf1K/E3CbyIJqAF+QacLqXGLkX0OVvtQ/xIOA/U+3cwHWwuRMAAAAASUVORK5CYII=",
          iconSize: [32, 37],
          iconAnchor: [16, 37]
      }),   
      iconT: icon({
        iconUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAABmJLR0QA/wD/AP+gvaeTAAAA/UlEQVRoge3XPQ6CQBAF4LdewYqIFzHY2CItlQmdZ5LSxMoWEzsb4SxWnmFsNAGzCy6RHX7mS0gQRuCxOwkLCCEGTdn+4RGuQ6UoJYCgaO9lxdVFncnMNgAUHQhYAPBBKnVWZ2AfAPBL+0uHdVpWU2hzepLu+G03V13W1WkzAr1i38TboPLWvEuuvca/60ymNQLSAx2QHuAmPcBNeoDbT2mP50w7V7uWxFHj8w1+BEYdoABA760iiSMkcdTZ75LP/e9tAqxqzrkWmE6MegoNggTgJgG4SQBuEoCbBOBWFyB39hTNjF+jsiLjNvgAtr5XaNoVm8vrTW4EhBA98wIG9JSz9GPIJAAAAABJRU5ErkJggg==",
        iconSize: [32, 37],
        iconAnchor: [16, 37]
      }), 
      markers: [

      ],
      mapOptions: {
        zoomSnap: 0.5,
      },
      showMap: true,
	  };
  },  
  mounted() {
    console.log('mounted');
    this.trafosInit();

    this.$refs.mapaCreg.mapObject.on('moveend', function() {
      console.log('moveend');
      var bounds = this.getBounds();
      var southWest = bounds.getSouthWest();
      var northEast = bounds.getNorthEast();

      console.log('bounds', bounds);
      console.log('southWest', southWest);
      console.log('northEast', northEast);

      const minLat = southWest.lat;
      const minLng = southWest.lng;
      const maxLat = northEast.lat;
      const maxLng = northEast.lng;
      
      let requestInput = {
        "minLat": minLat, "minLng": minLng,
        "maxLat": maxLat, "maxLng": maxLng
      };

      console.log('requestInput', requestInput);
      axios.post("request/consultarTransformadores", requestInput, {
        headers: {'Accept': 'application/json', 'Content-Type': 'application/json'}
      }).then((result) => {
        //this.items = result.data;
        this.items = trafos;
        this.markers = trafos;
        //console.log('this.items', this.items);
      }).catch((e) => {
        this.loading = false;
        this.error = 'Se ha producido un error, intentelo de nuevo más tarde.';
      })
    });

    return this.items;
  },
  created() {
    
  },
	methods: {
	  zoomUpdate(zoom) {
		  this.currentZoom = zoom;
	  },
	  centerUpdate(center) {
		  this.currentCenter = center;
	  },    
	  innerClick() {
		  
    },
    trafosInit() {
      console.log('trafosInit');
      
      let requestInput = {
        "minLat": 3.448128009200764, "minLng": -76.53637290000917,
        "maxLat": 3.4518762964327623, "maxLng": -76.53029501438142
      };

      console.log('requestInput', requestInput);
      axios.post("request/consultarTransformadores", requestInput, {
        headers: {'Accept': 'application/json', 'Content-Type': 'application/json'}
      }).then((result) => {
        //this.items = result.data;
        this.items = trafos;
        
        //console.log('this.items', this.items);
      }).catch((e) => {
        this.loading = false;
        this.error = 'Se ha producido un error, intentelo de nuevo más tarde.';
      })
      

      return this.items;
    },
    searchTrafos() {
      let busqueda = {"tipoConsulta": this.criterio, "valor": this.valorBusqueda};

      if (this.criterio == 'trafo') {
        console.log('Busqueda trafo');
        busqueda.tipoConsulta = 1;
      }

      if (this.criterio == 'nodo') {
        console.log('Busqueda nodo');
        busqueda.tipoConsulta = 2;
      }

      console.log(busqueda);
      var trafosBusqueda = [];
      axios.post("request/consultarDisponibilidad", busqueda, {
        headers: {'Accept': 'application/json', 'Content-Type': 'application/json'}
      }).then((result) => {
        trafosBusqueda = result.data;
        console.log('trafosBusqueda', trafosBusqueda);
      }).catch((e) => {
        this.loading = false;
        this.error = 'Se produjo un error, intentelo de nuevo más tarde.';
      });

      var trafo = trafosBusqueda[0];
      console.log('Resultado latitudTrafo', trafo.latitudTrafo);
      console.log('Resultado longitudTrafo', trafo.longitudTrafo);

      const nuevaUbicacion = [trafosBusqueda[0].latitudTrafo, trafosBusqueda[0].longitudTrafo];
      this.$refs.mapaCreg.mapObject.flyTo(nuevaUbicacion);

      this.iconT = icon({
        iconUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAABmJLR0QA/wD/AP+gvaeTAAAA/UlEQVRoge3XPQ6CQBAF4LdewYqIFzHY2CItlQmdZ5LSxMoWEzsb4SxWnmFsNAGzCy6RHX7mS0gQRuCxOwkLCCEGTdn+4RGuQ6UoJYCgaO9lxdVFncnMNgAUHQhYAPBBKnVWZ2AfAPBL+0uHdVpWU2hzepLu+G03V13W1WkzAr1i38TboPLWvEuuvca/60ymNQLSAx2QHuAmPcBNeoDbT2mP50w7V7uWxFHj8w1+BEYdoABA760iiSMkcdTZ75LP/e9tAqxqzrkWmE6MegoNggTgJgG4SQBuEoCbBOBWFyB39hTNjF+jsiLjNvgAtr5XaNoVm8vrTW4EhBA98wIG9JSz9GPIJAAAAABJRU5ErkJggg==",
        iconSize: [64, 74],
        iconAnchor: [32, 74],
        popupAnchor: [0, -62] 
      });

      var marker = L.marker(
        [trafo.latitudTrafo, trafo.longitudTrafo],
        {icon: this.iconT}
      ).addTo(this.$refs.mapaCreg.mapObject);

      var msg = '<span>Código del transformador:' + trafo.codigoTransformador
        + '</span><br/><span>Código del circuito:' + trafo.codigoCircuito
        + '</span><br/><span>Nombre del circuito:' + trafo.nombreCircuito
        + '</span><br/><span>Dirección del transformador: ' + trafo.direccionTransformador
        + '</span><br/><span>Potencia:' + trafo.potencia + ' kVA'
        + '</span><br/><span>Fases: ' + trafo.fases
        + '</span><br/><span>Código subestación: ' + trafo.codigoSubestacion + '</span>'
        + '</span><br/><span>Nombre subestación: ' + trafo.nombreSubestacion + '</span><br/>';

      marker.bindPopup(msg).openPopup();

    },
    getFechaHora() {
      const fecha = new Date();
      const year = fecha.getFullYear();
      const month = String(fecha.getMonth() + 1).padStart(2, '0');
      const day = String(fecha.getDate()).padStart(2, '0');
      const hour = String(fecha.getHours()).padStart(2, '0');
      return `${year}${month}${day}${hour}-*3mC4$v1+nT1k`;
    },
    encriptarToken() {
      try {
        const fechaHoraActual = this.getFechaHora();
        if (fechaHoraActual) {
          const resultadoHash = CryptoJS.MD5(fechaHoraActual);
          this.mensajeEncriptado = resultadoHash.toString(CryptoJS.enc.Hex).toUpperCase();
          return this.mensajeEncriptado;
        }
      } catch (error) {
        console.error(error);
        return '';
      }
    },
    getTrafos() {

      var bounds = this.$refs.mapaCreg.mapObject.getBounds();
      var southWest = bounds.getSouthWest();
      var northEast = bounds.getNorthEast();

      console.log('bounds', bounds);
      console.log('southWest', southWest);
      console.log('northEast', northEast);

      const minLat = southWest.lat;
      const minLng = southWest.lng;
      const maxLat = northEast.lat;
      const maxLng = northEast.lng;

      let requestInput = {
        "minLat": minLat, "minLng": minLng,
        "maxLat": maxLat, "maxLng": maxLng
      };

      console.log('requestInput', requestInput);
      axios.post("request/consultarTransformadores", requestInput, {
        headers: {
          'Accept': 'application/json', 'Content-Type': 'application/json'
        }
      }).then((result) => {                
        //this.items = result.data;
        this.trafosList = trafos;
        console.log('this.items', this.items);
      }).catch((e) => {
        this.loading = false;
        this.error = 'Se ha producido un error, intentelo de nuevo más tarde.';
      })

      return this.items;
    },
    encontrarMarkerYMostrar(posBuscada) {
      let marcadorEncontrado = false;
      let encontradoIndex = -1;
      for (var i = 0; i < this.$refs.popupRefs.length; i++){
        if (this.$refs.popupRefs[i].mapObject._latlng.lat === posBuscada[0] && this.$refs.popupRefs[i].mapObject._latlng.lng === posBuscada[1]) {
          marcadorEncontrado = true;
          encontradoIndex = i;
        }
      }

      if (marcadorEncontrado) {
        const markerRef = this.$refs.popupRefs[encontradoIndex];
        markerRef.mapObject.openPopup();
      } else {
        console.log("No se encontró un marcador en esa posición.");
      }
    },
	},
  //Creo un método llamado 'items' y obtengo los datos con el método map()  
  /*computed: {    
    items() { 
      console.log('computed');
      let trafosTmp = this.trafosInit();
      return trafosTmp.map((item) => {
        return item;
      })
    },
  }*/
};
  
</script>
  
<style>
  .sub{
    border-bottom: 1px solid red; color: black;
  }

  .list-group-item {
    padding: 0.2rem 1rem !important;
}
</style>
  